import classNames from 'classnames'

import Button from '../ui/Button/Button'
import BulletList from '../BulletList/BulletList'
import Image from '../ui/Image/Image'

import styles from './ImageDescriptionBullets.module.scss'
import arrowUpRight from '../../assets/images/arrowUpRight.svg'
import { getImageUrl } from '../../utils'

function ImageDescriptionBullets({
  bulletstitle,
  image,
  button,
  bulletssubsection = [],
  bulletsdescription,
  handleNavigation,
  className,
}) {
  return (
    <div className={classNames(styles.container, className)}>
      <h1 className={styles.bulletsTitle}>{bulletstitle}</h1>
      {(image || button) && (
        <div className={styles.imageContainer}>
          {image && (
            <div className={styles.image}>
              <Image src={getImageUrl(image)} alt={image?.alternativeText} />
            </div>
          )}
          {button && (
            <Button
              aria-label={button?.label}
              classname={styles.countryListButton}
              buttonDetails={button}
              text={button?.label}
              handleClick={handleNavigation}
            >
              <Image
                src={arrowUpRight}
                alt={button?.label}
                className={styles.btnImage}
              />
            </Button>
          )}
        </div>
      )}
      {bulletssubsection && (
        <div className={styles.descriptionContainer}>
          <div className={styles.descriptionHeaderContainer}>
            <h1>{bulletstitle}</h1>
            {bulletsdescription && <span>{bulletsdescription}</span>}
          </div>
          <BulletList
            bulletList={bulletssubsection}
            className={styles.bulletListContainer}
          />
          {button && (
            <Button
              aria-label={button?.label}
              classname={styles.countryListButton}
              buttonDetails={button}
              text={button?.label}
              handleClick={handleNavigation}
            >
              <Image
                src={arrowUpRight}
                alt={button?.label}
                className={styles.btnImage}
              />
            </Button>
          )}
        </div>
      )}
    </div>
  )
}

export default ImageDescriptionBullets
